import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { DMSIDS } from "models";

import type { DealerDMSIncadeaConfig } from "models";
import type { AddEditDealerFormPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal";

export type IncadeaConfig = Pick<
  DealerDMSIncadeaConfig,
  "dms_dealer_id" | "dms_appointment_type" | "dms_internal_intervention_id" | "dms_warranty_intervention_id" | "api_base_url" | "username" | "password"
>;

type IncadeaConfigProps = {
  dmsId: DMSIDS;
};

const FormHelper = createFormHelper<AddEditDealerFormPayload>();

export const IncadeaConfigSection = ({ dmsId }: IncadeaConfigProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid columns="equal">
        <GridColumn>
          <Form.Field>
            <label>{t("v8_dms_dealer_id", "DMS Dealer ID")} </label>
            <FormHelper.Field.Input name="incadea_config.dms_dealer_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_dms_appointment_type", "DMS Appointment Type")} </label>
            <FormHelper.Field.Input name="incadea_config.dms_appointment_type" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_dms_warranty_intervention_id", "DMS Warranty Intervention ID")} </label>
            <FormHelper.Field.Input name="incadea_config.dms_warranty_intervention_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_dms_internal_intervention_id", "DMS Internal Intervention ID")} </label>
            <FormHelper.Field.Input name="incadea_config.dms_internal_intervention_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>
      </Grid>

      {[DMSIDS.INCADEA_API, DMSIDS.INCADEA_HYBRID].includes(dmsId) && (
        <Grid columns="equal">
          <GridColumn>
            <Form.Field>
              <label>{t("v8_api_base_url", "API Base URL")} </label>
              <FormHelper.Field.Input name="incadea_config.api_base_url" inputProps={{ fluid: true }} />
            </Form.Field>
          </GridColumn>

          <GridColumn>
            <Form.Field>
              <label>{t("v8_username", "Username")} </label>
              <FormHelper.Field.Input name="incadea_config.username" inputProps={{ fluid: true }} />
            </Form.Field>
          </GridColumn>

          <GridColumn>
            <Form.Field>
              <label>{t("v8_password", "Password")} </label>
              <FormHelper.Field.Input name="incadea_config.password" inputProps={{ fluid: true }} />
            </Form.Field>
          </GridColumn>
        </Grid>
      )}
    </>
  );
};
